/**
 * Labstep
 *
 * @module components/Experiment/Form/ShowEdit/State/ExperimentFormShowEditStateExperimentActionEdit
 * @desc Button to switch to edit mode
 */

import { EntityActionEdit } from 'labstep-web/components/Entity/Action/Edit';
import type React from 'react';
import type { ExperimentFormShowEditStateExperimentActionEditProps } from './types';

export const ExperimentFormShowEditStateExperimentActionEdit: React.FC<
  ExperimentFormShowEditStateExperimentActionEditProps
> = ({ experiment, onClick, actionComponentProps = {} }) => (
  <EntityActionEdit
    entity={experiment}
    actionComponentProps={{
      type: 'text',
      ...actionComponentProps,
      onClick,
    }}
  />
);
